import { MerchantType } from '../features/Card/types';

function removeDuplicateMerchant(merchants: MerchantType[]) {
  return merchants.filter(
    (item, index, self) => index === self.findIndex((i) => i.id === item.id),
  );
}

export default removeDuplicateMerchant;
